import withFeatureFlag from "./featureflag";

export default withFeatureFlag;
